/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createSelector } from 'reselect';
import type { ApplicationPermissions } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createSubscriber,
	type BoundActions,
	type SubscriberComponent,
} from '@atlassian/react-sweet-state';
import Store from '../../store.tsx';
import type { Actions, State } from '../../types.tsx';
import { useTenantContext } from '../tenant-context/index.tsx';

type SelectorOutput = {
	data: {
		applicationPermissions: ApplicationPermissions;
	};
};

const selector = createSelector(
	(state: State) => state.tenantContext.appPermissions,
	(applicationPermissions) => ({
		data: { applicationPermissions },
	}),
);

export const ApplicationPermissionsSubscriber: SubscriberComponent<
	SelectorOutput,
	BoundActions<State, Actions>,
	undefined
> = createSubscriber<State, Actions, SelectorOutput, undefined>(Store, {
	displayName: 'ApplicationPermissionsSubscriber',
	selector,
});

/**
 * Returns the application permissions for the current user.
 *
 * @agent-skills: tenant-context
 */
export const useApplicationPermissions = (): ApplicationPermissions => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.appPermissions;
};
